import axios from 'axios'
import jwt from 'jwt-decode'

import Firebase from '../components/Firebase'
import { applyStaffFacilityScopeToRequest } from '../utils/staffFacility'

const baseUrl = process.env.REACT_APP_API_URI

export const api = axios.create({
	baseURL: `${baseUrl}/adminpetcare`,
	withCredentials: false
})

export default {
	setupInterceptors: (_store, history) => {
		api.interceptors.response.use(
			(response) => {
				return response
			},
			async (e) => {
				if (e.response) {
					// if (e.response.status === 404) {
					//   history.push("/404");
					// }

					if (e.response.status === 504) {
						history.push('/504')
					}

					if (e.response.status === 401 && !e.config.__isRetryRequest) {
						e.config.__isRetryRequest = true
						let user = Firebase.auth.currentUser
						if (user) {
							const token = await Firebase.auth.currentUser.getIdToken(true)
							e.config.headers['Authorization'] = `Bearer ${token}`
							return api.request(e.config)
						} else {
							return Promise.reject(e.response ? e.response : e)
						}
					} else {
						// const msg = await Promise.reject(e);
						return Promise.reject(e.response ? e.response : { message: 'Network Error' })
					}
				}
			}
		)

		api.interceptors.request.use(async (config) => {
			// Always send the signed-in user's current token. axios 1.x merges the default header
			// (set once at login) into config.headers, so checking for a missing header kept
			// sending the login token after it expired: every request got a 401 and a retry.
			// getIdToken() is cached and Firebase renews it before it expires. The 401 retry
			// above already carries a freshly forced token, so leave it alone.
			if (!config.__isRetryRequest) {
				let user = await getCurrentUser()
				if (user) {
					const token = await Firebase.auth.currentUser.getIdToken()
					config.headers['Authorization'] = `Bearer ${token}`
				}
			}

			const header = config.headers['Authorization'] || api.defaults.headers.common['Authorization']
			if (header) {
				try {
					const decoded = jwt(String(header).replace(/^Bearer\s+/i, ''))
					applyStaffFacilityScopeToRequest(config, {
						roles: decoded.roles || [],
						facility_id: decoded.facility_id
					})
				} catch (e) {}
			}

			return config
		})
	}
}

// The signed-in user, waiting for Firebase to restore the session on first load. The listener
// is removed once it has answered; it used to stay subscribed, one more per call.
const getCurrentUser = () => {
	if (Firebase.auth.currentUser) return Promise.resolve(Firebase.auth.currentUser)

	return new Promise((resolve, reject) => {
		let unsubscribe = null
		let done = false
		unsubscribe = Firebase.auth.onAuthStateChanged((user) => {
			done = true
			if (unsubscribe) unsubscribe()
			resolve(user)
		}, reject)
		// Firebase can answer synchronously, before `unsubscribe` is assigned.
		if (done) unsubscribe()
	})
}
